import { gql } from "graphql-tag";

export const manualFragments = gql`
  #
  # ───────────────────────────
  #  MANUAL FRAGMENTS
  # ───────────────────────────
  #

  # If you want a small fragment for product_Entry:
  fragment ProductEntryFields on product_Entry {
    userTitle
    pageLayoutType
    typeHandle
    productFamily
    productVariant
    productCategory {
      id
      title
      ... on productCategories_Category {
        role
      }
    }
    productFeatures {
      id
      title
    }
    productIcon {
      uid
      url
      width
      height
      focalPoint
      hasFocalPoint
    }
    scopedVariables: variables {
      ...VariableEntryFields
    }
  }

  # Similarly, if you want a fragment for chapter_Entry:
  fragment ChapterEntryFields on chapter_Entry {
    id
    userTitle
    typeHandle
    # Expand topicArticles to the various article fragments
    topicArticles {
      typeHandle
      ... on articleLongformComposableEntries_Entry {
        ...ArticleLongformComposableEntriesFields
      }
      ... on articleWithSteps_Entry {
        ...ArticleWithStepsFields
      }
      ... on articleLongform_Entry {
        ...ArticleLongformFields
      }
      ... on articleStepByStepComposableEntries_Entry {
        ...ArticleStepByStepComposableEntriesFields
      }
    }
  }
`;

export default manualFragments;
